module.exports = __webpack_public_path__ + "media/images/spree/frontend/logo-2e8fea7792ef59f87e086afd5efb0d57.png";